<script>
  export let buttonIcon = '';
  export let title = '';
  export let titleStyle = '';
  export let color = 'white';
  export let fontSize = 32;
  export let fontWeight = 500;
  export let minWidth = 200;
  export let maxHeight = 300;

  let isMenuOpen = false;
  let btnEl, menuEl;

  $: btnBounds = btnEl?.getBoundingClientRect();
  $: menuBounds = menuEl?.getBoundingClientRect();

  const onBtnClicked = (e) => {
    isMenuOpen = !isMenuOpen;
    btnBounds = btnEl?.getBoundingClientRect();
  };

  const onMenuContainerClicked = (e) => {
    if (isMenuOpen) {
      isMenuOpen = false;
    }
  };

  const onWindowResize = (e) => {
    btnBounds = btnEl?.getBoundingClientRect();
    menuBounds = menuEl?.getBoundingClientRect();
  };
</script>

<svelte:window on:resize={onWindowResize} />

<div class="container">
  <button on:click={onBtnClicked} bind:this={btnEl}>
    {#if buttonIcon}
      <span class="material-icons" style="color: {color}; font-size: {fontSize}px;">
        {buttonIcon}
      </span>
    {/if}
    {#if title}
      <span
        class="title"
        style="color: {color}; font-size: {fontSize}px; font-weight: {fontWeight}; {titleStyle}"
      >
        {title}
      </span>
    {/if}
  </button>
  {#if isMenuOpen}
    <div class="menu-container" on:click={onMenuContainerClicked}>
      <div
        class="menu"
        bind:this={menuEl}
        style="top: {btnBounds.top + btnBounds.height}px; left: {btnBounds.x +
          btnBounds.width -
          menuBounds?.width}px; width: {menuBounds?.width}px; min-width: {minWidth}px; max-height: {maxHeight}px;"
      >
        <slot />
      </div>
    </div>
  {/if}
</div>

<style src="./actionMenu.scss"></style>
